<template>
  <div>
    <SeriesList :series='series.results' :search='filter' detailLink="/admin/series" @add="showAddSeriesDialog = true" @filter="filter"></SeriesList>
    <md-dialog :md-active.sync="showAddSeriesDialog">
      <md-dialog-title>Add Series</md-dialog-title>
      <md-dialog-content>
        <form novalidate>
          <md-field :class="getValidationClass('title')">
            <label for="title">Title</label>
            <md-input name="title" id="title"  v-model="addSeries.title" />
              <span class="md-error" v-if="!$v.addSeries.title.required">The title is required</span>
          </md-field>
        </form>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="clearForm(); showAddSeriesDialog = false">Close</md-button>
        <md-button class="md-primary" @click="validateSeries()">Save</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>
<script>
import SeriesList from '@/components/SeriesList.vue'
import { mapState, mapGetters, mapActions } from 'vuex'
import { validationMixin } from 'vuelidate'
import {
  required,
  email,
  minLength,
  maxLength
} from 'vuelidate/lib/validators'

export default {
  name: "AdminSeriesList",
  mixins: [validationMixin],
  components:{
    SeriesList
  },
  data: function(){
    return {
      showAddSeriesDialog: false,
      addSeries: {
        title: ''
      }
    }
  },
  validations: {
    addSeries: {
      title: {
        required
      }
    }
  },
  methods: {
    ...mapActions({
      getSeries: 'getSeriesForAdmin',
      createSeries: 'createSeries',
      setSeriesFilter: 'setSeriesFilter'
    }),
    filter(search) {
      this.setSeriesFilter(search)
    },
    getValidationClass (fieldName) {
      const field = this.$v.addSeries[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    clearForm () {
      this.$v.$reset()
      this.addSeries.title = null
    },
    validateSeries: function() {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.createSeries(this.addSeries.title)
        this.clearForm()
        this.showAddSeriesDialog = false
      }
    }
  },
  computed: {
    ...mapGetters({
      series: 'filteredSeries' 
    })
  },
  created: function(){
    this.getSeries()
  }

}
</script>
<style>
</style>
